// LAB28 Profesor Widget (Shopify Horizon) - doradca produktowy AI
// Adaptacja z Shopera 2026-08-18: jasna paleta brandbook (#9420E9 / czern / biel),
// pigulki, ikona SVG zamiast emoji, polskie znaki, oznaczenie AI w naglowku.
// Backend bez zmian: profesor-api.php na irex.pl/lab28-assets (CORS + rate limit + katalog).
(function() {
  if (document.getElementById('lp')) return;
  // Nie inicjuj na koszyku/checkoucie - widget nie moze zaslaniac przyciskow zakupowych
  if (/^\/(cart|checkout)/.test(location.pathname)) return;
  window.__lab28_profesor_loaded = true;

  // Tryb cichy (ustawiany per szablon w snippets/lab28-profesor.liquid):
  // bez dymka, bez auto-uchylenia i bez etykiety przy ikonie. Zostaje sam
  // przycisk. Stosowany na stronach marki, gdzie pierwsze wrazenie robi hero.
  var PROACTIVE = window.LAB28_PROFESOR_PROACTIVE !== false;

  var API = 'https://irex.pl/lab28-assets/profesor-api.php';
  var hist = [];
  var open = false;
  var busy = false;

  // dataLayer tracking (no-op jesli brak GTM; Custom Pixel moze czytac pozniej)
  function track(event, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = {event: event};
      if (params) for (var k in params) if (params.hasOwnProperty(k)) payload[k] = params[k];
      window.dataLayer.push(payload);
    } catch(e) {}
  }

  function el(tag, attrs, children) {
    var e = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function(k) {
      if (k === 'text') e.textContent = attrs[k];
      else if (k === 'cls') e.className = attrs[k];
      else if (k === 'css') e.style.cssText = attrs[k];
      else e.setAttribute(k, attrs[k]);
    });
    if (children) children.forEach(function(c) { if (c) e.appendChild(c); });
    return e;
  }

  function chatIcon(size) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('width', size); svg.setAttribute('height', size);
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('fill', 'none');
    var p = document.createElementNS(ns, 'path');
    p.setAttribute('d', 'M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z');
    p.setAttribute('stroke', 'currentColor'); p.setAttribute('stroke-width', '2');
    p.setAttribute('stroke-linecap', 'round'); p.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(p);
    return svg;
  }

  // CSS - jasna paleta brandbook / Apple-like (spojna z motywem Horizon light)
  var css = el('style', {text: [
    '#lp{position:fixed;bottom:20px;right:20px;z-index:9999;font-family:inherit}',
    '#lp-wrap{display:flex;align-items:center;gap:10px;cursor:pointer}',
    '#lp-label{background:#ffffff;border:1px solid #E4E4EA;border-radius:980px;color:#111114;padding:8px 16px;font-size:13px;font-weight:500;white-space:nowrap;opacity:1;transition:opacity .3s;pointer-events:none;box-shadow:0 4px 16px rgba(0,0,0,.08)}',
    '#lp-label strong{color:#9420E9}',
    '#lp-t{width:56px;height:56px;background:#9420E9;color:#fff;border-radius:50%;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 4px 16px rgba(148,32,233,.35);transition:transform .2s,background .2s;border:none}',
    '#lp-t:hover{transform:scale(1.08);background:#7A1AC2}',
    '@keyframes lp-slidein{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}',
    '#lp-w{width:380px;max-width:calc(100vw - 40px);height:520px;max-height:calc(100vh - 100px);background:#ffffff;border:1px solid #E4E4EA;border-radius:18px;flex-direction:column;box-shadow:0 16px 48px rgba(0,0,0,.14);overflow:hidden}',
    '#lp-h{display:flex;align-items:center;justify-content:space-between;padding:14px 18px;background:#ffffff;border-bottom:1px solid #E4E4EA}',
    '#lp-h strong{display:block;color:#111114;font-size:15px;font-weight:700}',
    '#lp-h span{color:#5C5C66;font-size:12px}',
    '#lp-x{background:none;border:none;color:#8E8E96;font-size:24px;cursor:pointer;line-height:1}',
    '#lp-x:hover{color:#111114}',
    '#lp-m{flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:10px;background:#ffffff}',
    '.pm{max-width:85%;padding:10px 14px;font-size:13px;line-height:1.5;word-wrap:break-word}',
    '.pb{align-self:flex-start;background:#F5F5F5;color:#111114;border-radius:16px 16px 16px 4px}',
    '.pu{align-self:flex-end;background:#9420E9;color:#ffffff;border-radius:16px 16px 4px 16px}',
    '.pb a{color:#9420E9;text-decoration:underline}',
    '.pb a:hover{color:#7A1AC2}',
    '.pb strong{color:#111114}',
    '.pl{align-self:flex-start;color:#8E8E96;font-style:italic;font-size:12px;padding:6px 14px}',
    '#lp-i{display:flex;padding:12px;gap:8px;border-top:1px solid #E4E4EA;background:#ffffff}',
    '#lp-f{flex:1;background:#ffffff;border:1px solid #D6D6D6;border-radius:12px;color:#111114;padding:10px 14px;font-size:13px;font-family:inherit;outline:none}',
    '#lp-f:focus{border-color:#9420E9}',
    '#lp-f::placeholder{color:#9a9aa4}',
    '#lp-s{background:#9420E9;color:#fff;border:none;border-radius:980px;padding:0 16px;font-size:16px;cursor:pointer;transition:background .2s}',
    '#lp-s:hover{background:#7A1AC2}',
    '#lp-s:disabled{background:#D6D6D6;cursor:not-allowed}',
    '#lp-ai{font-size:10px;color:#9a9aa4;text-align:center;padding:0 12px 8px;background:#ffffff}',
    '@media(max-width:480px){#lp-label{display:none}#lp-t{width:48px;height:48px}#lp{bottom:12px;right:12px}#lp-w{width:100vw;height:calc(100vh - 60px);max-height:calc(100vh - 60px);max-width:100vw;position:fixed;bottom:0;left:0;right:0;border-radius:18px 18px 0 0;border-bottom:none}#lp-i{padding-bottom:calc(12px + env(safe-area-inset-bottom))}}'
  ].join('\n')});
  document.head.appendChild(css);

  // Build DOM
  var root = el('div', {id:'lp'});

  var wrap = el('div', {id:'lp-wrap'});
  var label = el('div', {id:'lp-label'});
  var labelStrong = el('strong', {text:'Zapytaj Profesora'});
  label.appendChild(labelStrong);
  label.appendChild(document.createTextNode(', dobierzemy produkty'));
  if (!PROACTIVE) label.style.display = 'none';
  wrap.appendChild(label);
  var tgl = el('button', {id:'lp-t','aria-label':'Otwórz czat z Profesorem'});
  tgl.appendChild(chatIcon(26));
  wrap.appendChild(tgl);
  root.appendChild(wrap);

  var win = el('div', {id:'lp-w', css:'display:none'});

  var hdr = el('div', {id:'lp-h'});
  var ttl = el('div');
  var ts = el('strong', {text:'Profesor'});
  var td = el('span', {text:'Doradca produktowy AI · LAB28'});
  ttl.appendChild(ts);
  ttl.appendChild(td);
  var xbtn = el('button', {id:'lp-x','aria-label':'Zamknij', text:'×'});
  hdr.appendChild(ttl);
  hdr.appendChild(xbtn);
  win.appendChild(hdr);

  var msgs = el('div', {id:'lp-m'});
  var welcome = el('div', {cls:'pm pb', text:'Cześć! Jestem Profesor, doradca produktowy AI sklepu LAB28. Powiedz mi, co chcesz zrobić ze swoim autem, a dobiorę odpowiednie produkty.'});
  msgs.appendChild(welcome);
  win.appendChild(msgs);

  var iw = el('div', {id:'lp-i'});
  var inp = el('input', {id:'lp-f', type:'text', placeholder:'Napisz wiadomość...', maxlength:'500', autocomplete:'off'});
  var sbtn = el('button', {id:'lp-s','aria-label':'Wyślij', text:'➞'});
  iw.appendChild(inp);
  iw.appendChild(sbtn);
  win.appendChild(iw);

  var ai = el('div', {id:'lp-ai', text:'Odpowiedzi generuje sztuczna inteligencja. Mogą zdarzyć się błędy.'});
  win.appendChild(ai);

  root.appendChild(win);
  document.body.appendChild(root);

  // Safe markdown parser (DOM-based, no innerHTML)
  function parseMd(text) {
    var frag = document.createDocumentFragment();
    var lines = text.split('\n');
    for (var i = 0; i < lines.length; i++) {
      if (i > 0) frag.appendChild(document.createElement('br'));
      var line = lines[i];
      var rx = /(\*\*\[([^\]]+)\]\(([^)]+)\)\*\*|\[([^\]]+)\]\(([^)]+)\)|\*\*([^*]+)\*\*)/g;
      var last = 0;
      var m;
      while ((m = rx.exec(line)) !== null) {
        if (m.index > last) frag.appendChild(document.createTextNode(line.substring(last, m.index)));
        if (m[2] && m[3]) {
          var a = el('a', {href: m[3], text: m[2]});
          var s = el('strong');
          s.appendChild(a);
          frag.appendChild(s);
        } else if (m[4] && m[5]) {
          frag.appendChild(el('a', {href: m[5], text: m[4]}));
        } else if (m[6]) {
          frag.appendChild(el('strong', {text: m[6]}));
        }
        last = m.index + m[0].length;
      }
      if (last < line.length) frag.appendChild(document.createTextNode(line.substring(last)));
    }
    return frag;
  }

  function addMsg(text, role) {
    var d = el('div', {cls: 'pm ' + (role === 'user' ? 'pu' : 'pb')});
    if (role === 'assistant') d.appendChild(parseMd(text));
    else d.textContent = text;
    msgs.appendChild(d);
    msgs.scrollTop = msgs.scrollHeight;
  }

  function send() {
    var t = inp.value.trim();
    if (!t || busy) return;
    addMsg(t, 'user');
    hist.push({role:'user', content:t});
    track('profesor_message_sent', {
      message_length: t.length,
      message_index: hist.filter(function(m){return m.role==='user';}).length
    });
    inp.value = '';
    busy = true;
    sbtn.disabled = true;
    var ld = el('div', {cls:'pl', id:'lp-ld', text:'Profesor pisze...'});
    msgs.appendChild(ld);
    msgs.scrollTop = msgs.scrollHeight;

    fetch(API, {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({messages: hist})
    })
    .then(function(r){return r.json()})
    .then(function(d){
      var l = document.getElementById('lp-ld');
      if (l) l.remove();
      if (d.error) addMsg(d.error, 'assistant');
      else if (d.reply) {
        addMsg(d.reply, 'assistant');
        hist.push({role:'assistant', content:d.reply});
      }
    })
    .catch(function(){
      var l = document.getElementById('lp-ld');
      if (l) l.remove();
      addMsg('Błąd połączenia. Spróbuj ponownie.', 'assistant');
    })
    .finally(function(){busy=false;sbtn.disabled=false;inp.focus()});
  }

  function setOpen(state){
    open = state;
    win.style.display = open ? 'flex' : 'none';
    wrap.style.display = open ? 'none' : 'flex';
    if (open) { cancelProactive(); hideBubble(); track('profesor_open'); inp.focus(); }
  }

  wrap.addEventListener('click', function(){ setOpen(!open); });
  // Klikniecia w linki produktowe: Shopify /products/<handle> + legacy /pl/p/<slug>/<id>
  msgs.addEventListener('click', function(e){
    var a = e.target.closest ? e.target.closest('a') : null;
    if (!a || !a.href) return;
    var m = a.href.match(/\/pl\/p\/([^\/]+)\/(\d+)/);
    if (m) { track('profesor_product_link_click', {product_id: m[2], product_slug: m[1]}); return; }
    var s = a.href.match(/\/products\/([a-z0-9-]+)/);
    if (s) track('profesor_product_link_click', {product_slug: s[1]});
  });
  xbtn.addEventListener('click', function(){ setOpen(false); });
  sbtn.addEventListener('click', send);
  inp.addEventListener('keydown', function(e){
    if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();send()}
  });

  // Proaktywnosc: 6s dymek, 20s auto-uchylenie, 1x/sesja
  var bubbleTimer = null, autoOpenTimer = null, bubbleEl = null;
  function ss(key, val){ try { if (val === undefined) return sessionStorage.getItem(key); sessionStorage.setItem(key, val); } catch(e){ return null; } }

  function hideBubble(){ if (bubbleEl) { bubbleEl.remove(); bubbleEl = null; } }

  function showBubble(){
    if (open || bubbleEl || ss('lab28_prof_bubble')) return;
    ss('lab28_prof_bubble', '1');
    bubbleEl = el('div', {css:
      'position:absolute;bottom:70px;right:0;width:230px;background:#ffffff;color:#111114;' +
      'padding:14px 32px 14px 16px;border-radius:14px;font-size:14px;line-height:1.45;' +
      'border:1px solid #E4E4EA;box-shadow:0 12px 32px rgba(0,0,0,.12);cursor:pointer;animation:lp-slidein .35s ease;' +
      'font-family:inherit;'});
    bubbleEl.appendChild(document.createTextNode('Nie wiesz co wybrać? '));
    var s = el('strong', {text:'Dobiorę produkty do Twojego auta.'});
    s.style.color = '#9420E9';
    bubbleEl.appendChild(s);
    var bx = el('span', {text:'×', css:'position:absolute;top:8px;right:10px;color:#9a9aa4;font-size:16px;line-height:1;'});
    bx.addEventListener('click', function(e){
      e.stopPropagation(); hideBubble(); cancelProactive();
      ss('lab28_prof_autoopen', '1');
      track('profesor_proactive_dismiss');
    });
    bubbleEl.appendChild(bx);
    bubbleEl.addEventListener('click', function(){ setOpen(true); });
    root.appendChild(bubbleEl);
    track('profesor_proactive_shown');
  }

  function autoOpen(){
    if (open || ss('lab28_prof_autoopen')) return;
    ss('lab28_prof_autoopen', '1');
    track('profesor_autoopen');
    setOpen(true);
  }

  function cancelProactive(){
    if (bubbleTimer) { clearTimeout(bubbleTimer); bubbleTimer = null; }
    if (autoOpenTimer) { clearTimeout(autoOpenTimer); autoOpenTimer = null; }
  }

  // Proaktywnosc da sie wylaczyc per szablon (snippets/lab28-profesor.liquid).
  // Na stronach marki wysylanych producentowi widget ma czekac zwyniety,
  // zeby nie zaslanial hero przy wejsciu. Launcher zostaje.
  // 25.08.2026: autootwarcie WYLACZONE decyzja wlasciciela. Dane GA4 za 20-24.08:
  // 26 wymuszonych pokazan, 23 autootwarcia z 24 otwarc ogolem, 2 klikniecia w CTA.
  // Widget otwieral sie sam prawie kazdemu i prawie nikt nic z nim nie robil.
  // Dymek zostaje - sygnalizuje pomoc, nie zaslania strony. Funkcja autoOpen()
  // celowo zostaje w kodzie, zeby dalo sie to cofnac jedna linia.
  if (PROACTIVE && !ss('lab28_prof_autoopen')) {
    if (!ss('lab28_prof_bubble')) bubbleTimer = setTimeout(showBubble, 6000);
  }

  // Chowaj widget gdy otwarty jest dowolny dialog motywu (cart drawer,
  // quick-add, search modal) - Horizon renderuje je jako <dialog open>
  // i widget zaslanial przyciski koszyka
  function updateVis() {
    var dlg = document.querySelector('dialog[open]');
    root.style.display = dlg ? 'none' : '';
  }
  try {
    var mo = new MutationObserver(updateVis);
    mo.observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['open']});
    updateVis();
  } catch(e) {}
})();
